import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
  itemStatus: "idle",
  itemInfo: null,
  itemError: null,
}

export const addItem = createAsyncThunk(
  "add/addItem",
  async ({token,values}, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        "/api/product/add",values,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
      )
      return data
    } catch (err) {
      return rejectWithValue(err.response.data)
    }
  }
)
export const additemSlice = createSlice({
  name: "closet",
  initialState,
  reducers: {
    resetItem(state,action){
      state.itemInfo = null
      state.itemStatus="idle"
      state.itemError= null
    }
  },
  extraReducers: {
    [addItem.pending]: (state, action) => {
      state.itemStatus = "loading"
    },
    [addItem.fulfilled]: (state, action) => {
      state.itemStatus = "succeeded"
      state.itemInfo = action.payload
    },
    [addItem.rejected]: (state, action) => {
      state.itemStatus = "failed";
      state.itemError = action.payload
    },
  },
})

export const { resetItem } = additemSlice.actions
export default additemSlice.reducer 